export const navItems = [
  { id: "home", label: "首页" },
  { id: "hot", label: "热门推荐" },
  { id: "guide", label: "观看指南" },
  { id: "schedule", label: "上线节奏" },
  { id: "classics", label: "经典必看" },
  { id: "tips", label: "追剧攻略" },
  { id: "faq", label: "常见问题" },
];

export const quickStats = [
  { value: "9", label: "精选剧目", icon: "ri-film-line" },
  { value: "7", label: "类型分区", icon: "ri-price-tag-3-line" },
  { value: "3", label: "观看方式", icon: "ri-device-line" },
  { value: "周更", label: "追剧节奏", icon: "ri-calendar-check-line" },
];

export const watchChannels = [
  {
    icon: "ri-computer-line",
    title: "网页版入口",
    subtitle: "适合电脑与办公场景",
    desc: "在浏览器中直接打开页面即可浏览与播放，无需额外安装客户端。适合在大屏幕上边处理事务边追剧，也能快速切换剧集与清晰度。",
    points: ["浏览器直达，免安装", "大屏观影，多标签切换", "支持键盘快捷键操作"],
  },
  {
    icon: "ri-smartphone-line",
    title: "手机在线看",
    subtitle: "适合通勤与碎片时间",
    desc: "页面会自适应移动屏幕，竖屏浏览剧集列表、横屏进入播放。适合在通勤、排队等零碎时间进行短时观看，进度可随时接续。",
    points: ["自适应手机屏幕", "横竖屏自由切换", "碎片时间随时接续"],
  },
  {
    icon: "ri-play-circle-line",
    title: "在线播放",
    subtitle: "通用播放体验说明",
    desc: "在线播放通常包含清晰度选择、断点续看、片单收藏等通用能力。不同渠道的功能细节存在差异，使用前可先确认是否支持你需要的选项。",
    points: ["清晰度可选", "断点续看", "片单收藏与整理"],
  },
];

export const scheduleRhythm = [
  {
    phase: "档期安排",
    title: "月火 / 水木 / 周末档",
    desc: "韩剧多按固定档期更新，常见的有月火、水木与周末档。理解档期后，就能大致预判一周里哪几天会有更新，方便安排追剧时间。",
  },
  {
    phase: "制作模式",
    title: "事前制作与边拍边播",
    desc: "部分剧集采用事前一气呵成的制作模式，更新节奏相对稳定；也有作品边拍边播，更新与完结时间可能随拍摄进度而有所调整。",
  },
  {
    phase: "更新节奏",
    title: "一周一到两集的追更",
    desc: "大多数剧集每周更新一到两集，配合预告、花絮与幕后内容延续讨论热度。喜欢被剧情牵着的观众，适合跟着更新的节奏慢慢追。",
  },
  {
    phase: "完结整理",
    title: "完结后一口气看完",
    desc: "如果不想被周更打断，可以等全剧完结后再连续观看。整体看完更适合理解复杂的人物关系和伏笔回收，也不用担心被中途剧透。",
  },
];

export const classics = [
  {
    rank: "01",
    title: "大长今",
    year: "2003",
    genre: "古装励志",
    reason: "以女性成长与宫廷厨房为线索的经典长剧，把坚持、师徒与家国情感铺陈得厚重耐看。",
  },
  {
    rank: "02",
    title: "冬季恋歌",
    year: "2002",
    genre: "纯爱经典",
    reason: "早期爱情剧的代表之一，用冬日雪景与克制情感奠定了一代观众对韩式纯爱的印象。",
  },
  {
    rank: "03",
    title: "信号",
    year: "2016",
    genre: "悬疑推理",
    reason: "以跨越时空的对讲机串联多个案件，结构精巧，把推理张力与人性抉择结合得相当出色。",
  },
  {
    rank: "04",
    title: "我的解放日志",
    year: "2022",
    genre: "现实治愈",
    reason: "聚焦普通人的疲惫与自我和解，台词节制、情绪真实，很适合在压力大的时候慢慢看。",
  },
  {
    rank: "05",
    title: "未生",
    year: "2014",
    genre: "职场写实",
    reason: "以职场新人的视角还原真实的上班日常，被很多观众当作了解职场与人际的入门参考。",
  },
];

export const tips = [
  {
    icon: "ri-closed-captioning-line",
    title: "字幕与配音的选择",
    desc: "按需在字幕与配音之间取舍：想感受原声表演与语气，优先看带字幕版本；想边做别的事边追，配音版本更省力。",
  },
  {
    icon: "ri-speed-up-line",
    title: "倍速与观看节奏",
    desc: "日常剧可用 1.25 至 1.5 倍速压缩拖沓桥段，但悬疑推理剧建议原速观看，避免错过关键伏笔与细节镜头。",
  },
  {
    icon: "ri-eye-off-line",
    title: "防剧透的小习惯",
    desc: "追更期间可暂时关闭相关话题的评论区与推荐流，等自己看到最新一集后再回看讨论，观感会完整很多。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "片单与进度管理",
    desc: "把想看的剧先加入片单，按类型或心情分组，再借助断点续看去管理进度，追多部剧时不容易记混。",
  },
  {
    icon: "ri-history-line",
    title: "经典与新剧搭配",
    desc: "把经典老剧与新剧交替安排：新剧紧跟话题与讨论，老剧用来放松和回味，追剧的疲劳感会小很多。",
  },
  {
    icon: "ri-links-line",
    title: "渠道与合规提醒",
    desc: "选择观看渠道时，优先确认来源是否正规、是否具备相应授权。本站仅整理信息与观剧线索，不提供影视资源本身。",
  },
];

export const faqs = [
  {
    q: "韩剧TV 网页版入口要怎么找？",
    a: "网页版入口通常指无需安装客户端、直接用浏览器打开即可浏览与播放的渠道。使用时可以先确认页面是否为对应渠道的官方入口，再留意清晰度、字幕与播放稳定性等基础功能是否齐全。",
  },
  {
    q: "手机在线看需要注意什么？",
    a: "手机观看建议在稳定的网络环境下进行，并留意流量消耗；横屏播放时先确认自动旋转是否开启。若使用第三方应用或浏览器插件，也应确认其来源与权限是否合理。",
  },
  {
    q: "在线播放经常卡顿怎么办？",
    a: "可以先尝试降低清晰度、切换网络或关闭后台占用带宽的程序。如果同一渠道持续卡顿，多半与网络环境或服务端负载有关，可以换个时间段或换一个渠道再试。",
  },
  {
    q: "“免费看剧”的说法可信吗？",
    a: "遇到“完全免费”“无广告无限制”这类过于绝对的说法时，建议保持谨慎：留意是否有版权授权、是否诱导下载未知程序。剧情内容本身受版权保护，优先选择有正规授权的渠道会更稳妥。",
  },
  {
    q: "能不能不注册直接观看？",
    a: "不同渠道的规则差异较大：有的允许游客直接浏览与播放，有的需要登录后才能收藏片单或同步进度。是否需要注册取决于具体渠道，遇到要求填写敏感信息或付费的情况请谨慎判断。",
  },
  {
    q: "怎么快速确定一部剧值不值得追？",
    a: "可以先用类型、年份与主创信息快速筛掉不感兴趣的题材，再读一段不涉及关键情节的简介确认基调。悬疑剧尤其要避免提前看到结局相关内容，以免影响观感。",
  },
];

export const testimonials = [
  {
    name: "小满",
    tag: "悬疑剧爱好者",
    text: "习惯按类型找剧，先看简介确认基调再决定要不要追。追更的时候尽量不看评论区，等自己看完再回来翻讨论，体验好很多。",
  },
  {
    name: "阿哲",
    tag: "通勤追剧党",
    text: "每天通勤路上用手机看两集，横屏播放加断点续看，基本不耽误进度。周末再一口气补完本周更新，节奏刚好。",
  },
  {
    name: "Lina",
    tag: "治愈剧粉丝",
    text: "压力大的时候更愿意看生活流的剧，剧情不需要太抓人，看着几个人认真过日子就很放松。老剧翻来覆去地看也完全不腻。",
  },
  {
    name: "老周",
    tag: "经典剧补看",
    text: "新剧跟着更新追，老剧留着慢慢补。把经典当背景音一样放着，反而更容易注意到以前忽略的细节和台词。",
  },
];